import { render } from "./MessageThreadListView.vue?vue&type=template&id=8bf90b44"
import script from "./MessageThreadListView.vue?vue&type=script&lang=js"
export * from "./MessageThreadListView.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__